import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import { modalStore } from 'apps/modals/app';

import Paragraph from 'components/Paragraph';
import Button from 'components/Button';
import { Dot } from 'apps/components/shared';
import { ActivationForm } from 'apps/forum/activationForm/index';

import { ButtonsWrapper } from 'apps/repository/styles';
import { Wrapper, HeadingStyled } from 'apps/forum/views/activate.styles';

export const ActivateForum = withNamespaces()(props => {
  const { initiative, forumManager } = props;
  const {
    inSpace: { whichTypes },
  } = initiative;

  const button = whichTypes.includes('Forum') && (
    <ButtonsWrapper>
      <Button
        onClick={() =>
          modalStore.SetModalComponent(ActivationForm, {
            spaceId: initiative.inSpace.id,
            forumManager,
            initiativeTitle: initiative.title,
          })
        }
        size='small'
        text={<Trans>Activate</Trans>}
      />
    </ButtonsWrapper>
  );

  return (
    <Wrapper>
      {button}
      <HeadingStyled level={2} size='medium'>
        Your Forum is deactivated
        <Dot>●</Dot>
      </HeadingStyled>
      <Paragraph>
        Forums on Wikifactory give you everything you need to build a great
        online community.
      </Paragraph>
    </Wrapper>
  );
});

ActivateForum.propTypes = {
  initiative: PropTypes.object,
  forumManager: PropTypes.object,
};
